import { Component, computed, effect, input } from '@angular/core';
import { FieldTree, FormField } from '@angular/forms/signals';
import { MatInputModule, MatSuffix } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { SystemVoltage } from '../system-voltage/system-voltage.model';
import { achvCaseSelect, aclvCaseSelect, dcCaseSelect, Earthing } from './earthing.model';


@Component({
  selector: 'cable-edit-earthing',
  imports: [FormField,MatSelectModule, MatInputModule, MatSuffix],
  templateUrl: './earthing.component.html',
  styles: ``,
})
export class EarthingComponent {

  readonly form = input.required<FieldTree<Earthing>>();
  readonly systemVoltage = input.required<FieldTree<SystemVoltage>>();

  readonly dcCaseOpitons = dcCaseSelect;
  readonly aclvCaseOptions = aclvCaseSelect;
  readonly achvCaseOptions = achvCaseSelect;

  isDCCase = computed(() => this.systemVoltage().case().value() === 'dc');
  isACLVCase = computed(() => {
    let is1phLV = (this.systemVoltage().case().value() === 'ac1ph') && (this.systemVoltage().u0().value() <= 600);
    let is3phLV = (this.systemVoltage().case().value() === 'ac3ph') && (this.systemVoltage().u().value() <= 1000);
    let isTPN = (this.systemVoltage().case().value() === 'tpn') && (this.systemVoltage().u().value() <= 1000);
    return is1phLV || is3phLV || isTPN;
  });
  isACHVCase = computed(() => !this.isDCCase() && !this.isACLVCase());
  earthCase = computed(() => {
    if (this.isDCCase()) return 'dc';
    if (this.isACLVCase()) return 'aclv';
    if (this.isACHVCase()) return 'achv';
  });

  isIsolatedEarth = computed(() =>
    this.isDCCase() ? this.form().dcCase().value() === 'isolated' :
    this.isACLVCase() ? this.form().aclvCase().value() === 'it' :
    false
  );
  resetsoilResistivityErrorIfIsolatedEarth = effect(() => {
    if (this.isIsolatedEarth() && this.form().soilResistivity().errors().length > 0) {
      this.form().soilResistivity().value.set(0);
    }
  });

constructor() {


  effect(() => {

    if (this.earthCase() === 'dc' && this.form().case().value() !== 'dc')
      this.form().case().value.set('dc');

    if (this.earthCase() === 'aclv' && this.form().case().value() !== 'aclv')
      this.form().case().value.set('aclv');

    if (this.earthCase() === 'achv' && this.form().case().value() !== 'achv')
      this.form().case().value.set('achv');


  });


}

}
